const documents = {};

export default documents;
